<template>
  <div class="wrapper">
  <!-- UTENTE NON AUTENTICATO-->
    <div>
      <div class="full-screen"><!--main-panel-->
        <dashboard-content @click.native="toggleSidebar">
        </dashboard-content>
        <content-footer></content-footer>
      </div>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
//import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
//import MobileMenu from "./MobileMenu";
export default {
  components: {
    //TopNavbar,
    ContentFooter,
    DashboardContent
    //MobileMenu
  },

  data() {
    return {
      isLogged: localStorage.isLogged
    };
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    main: function() {}
  },
  mounted: function() {
    //this.main();
    console.log("this.isLogged: " + this.isLogged);
  }
};
</script>
